module.exports = __webpack_public_path__ + "static/media/22.38051830.jpg";